import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import Image from '../Image';

import { SliderWrapper } from '../ProductGallery/ProductGalleryStyles';

var CustomCollectionGallery = function CustomCollectionGallery(props) {
  return React.createElement(
    'div',
    null,
    React.createElement(
      SliderWrapper,
      { className: 'ProductSliderWrapper' },
      React.createElement(
        Slider,
        {
          className: 'ProductSlider CustomCollectionSlider',
          infinite: false,
          slidesToShow: 2,
          rows: 1,
          slidesToScroll: 1,
          initialSlide: 0,
          dots: true,
          responsive: [{
            breakpoint: 768,
            settings: {
              slidesToShow: 1
            }
          }]
        },
        props.customCollectionImages && props.customCollectionImages.map(function (img) {
          return React.createElement(Image, { key: img.src, src: img.src, alt: img.alt });
        })
      )
    )
  );
};

CustomCollectionGallery.propTypes = {
  title: PropTypes.string,
  collectionImage: PropTypes.string,
  customCollectionImages: PropTypes.array
};

export default CustomCollectionGallery;